/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cp_freq_monthly = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly`)
};

const es_cp_freq_monthly = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensual`)
};

const de_cp_freq_monthly = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monatlich`)
};

const nl_cp_freq_monthly = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maandelijks`)
};

const fr_cp_freq_monthly = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensuellement`)
};

const it_cp_freq_monthly = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensilmente`)
};

const pt_br2_cp_freq_monthly = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensalmente`)
};

const pt_cp_freq_monthly = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensalmente`)
};

const ja_cp_freq_monthly = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`毎月`)
};

const zh_cp_freq_monthly = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每月`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cp_freq_monthly = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cp_freq_monthly(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cp_freq_monthly", locale)
	if (locale === "en") return en_cp_freq_monthly(inputs)
	if (locale === "es") return es_cp_freq_monthly(inputs)
	if (locale === "de") return de_cp_freq_monthly(inputs)
	if (locale === "nl") return nl_cp_freq_monthly(inputs)
	if (locale === "fr") return fr_cp_freq_monthly(inputs)
	if (locale === "it") return it_cp_freq_monthly(inputs)
	if (locale === "pt-BR") return pt_br2_cp_freq_monthly(inputs)
	if (locale === "pt") return pt_cp_freq_monthly(inputs)
	if (locale === "ja") return ja_cp_freq_monthly(inputs)
	return zh_cp_freq_monthly(inputs)
};